import jsQR from "jsqr";

const toGrayscale = (pixels: Uint8ClampedArray): Uint8ClampedArray => {
  const grayscale = new Uint8ClampedArray(pixels);

  for (let index = 0; index < grayscale.length; index += 4) {
    // Rec. 601 keeps high-saturation green QR modules dark enough for jsQR's
    // adaptive binarizer while preserving ordinary black-and-white QR images.
    const luminance = Math.round(
      pixels[index] * 0.299 + pixels[index + 1] * 0.587 + pixels[index + 2] * 0.114
    );
    grayscale[index] = luminance;
    grayscale[index + 1] = luminance;
    grayscale[index + 2] = luminance;
  }

  return grayscale;
};

export const decodeQRCode = (
  pixels: Uint8ClampedArray,
  width: number,
  height: number
): string | null => {
  const directResult = jsQR(pixels, width, height);

  if (directResult?.data) {
    return directResult.data;
  }

  return jsQR(toGrayscale(pixels), width, height)?.data || null;
};
